import { Component, Input, inject } from '@angular/core';
import { RootReducer, Store } from '@app/app.reducers';
import { CustomHtmlBlockContent, getContentByKey } from '@app/core/reducers/content.reducer';
import { ApiSelector } from '@granodigital/grano-remote-data';

/** A component for rendering custom blocks of trusted HTML content. */
@Component({
	selector: 'g-custom-html-block',
	templateUrl: './custom-html-block.component.html',
	styleUrls: ['./custom-html-block.component.scss'],
	standalone: false,
})
export class CustomHtmlBlockComponent {
	private readonly store = inject<Store<RootReducer.State>>(Store);

	content$: ApiSelector<CustomHtmlBlockContent> | undefined;
	/** Set the key for the custom HTML block. */
	@Input() set key(key: string) {
		this.content$ = this.store.select(getContentByKey<CustomHtmlBlockContent>(key));
	}
}
